module.exports = __webpack_public_path__ + "media/KikiL.b344005b.mp3";